import React from "react";
import { Cell, Pie, PieChart } from "recharts";
import { formatScore } from "./performanceFormat";
import styles from "./resourceInsights.module.scss";

const WIDTH = 190;
const HEIGHT = 108;
const TRACK_COLOR = "#ece7fd";

/**
 * A half-circle gauge from 0 to 100 with the score in the middle, drawn in the colour of its status. Without a
 * score only the empty track is drawn.
 */
export default function PerformanceGauge({ score, color }) {
  const value = score === null || score === undefined ? 0 : Math.min(100, Math.max(0, score));
  const data = [
    { name: "score", value },
    { name: "rest", value: 100 - value },
  ];

  return (
    <div className={styles.gauge} style={{ width: WIDTH, height: HEIGHT }}>
      <PieChart width={WIDTH} height={HEIGHT}>
        <Pie
          data={data}
          dataKey="value"
          cx={WIDTH / 2}
          cy={HEIGHT - 6}
          startAngle={180}
          endAngle={0}
          innerRadius={66}
          outerRadius={88}
          stroke="none"
          cornerRadius={value > 0 && value < 100 ? 6 : 0}
          isAnimationActive
        >
          <Cell fill={color} />
          <Cell fill={TRACK_COLOR} />
        </Pie>
      </PieChart>

      <div className={styles.gaugeCenter}>
        <strong style={{ color }}>{formatScore(score)}</strong>
        <span>out of 100</span>
      </div>
    </div>
  );
}
